const itemsCommision = [
	{
		id: 0,
		key: 0,
		name: "status.eearned"
	},
	{
		id: 1,
		key: 1,
		name: "status.approved"
	},
	{
		id: 2,
		key: 2,
		name: "status.inPayout"
	},
	{
		id: 3,
		key: 3,
		name: "status.paid"
	},
	{
		id: 4,
		key: 4,
		name: "status.cancelled"
	}
];
export default itemsCommision;

